import React from "react";
import { JsxEmit } from "typescript";

export interface IconProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}
export const ProductIcon = ({ width, height, color }: IconProps): JSX.Element => (
  <svg width={width} height={height} viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M29.25 36.2461H6.75C3.02175 36.2461 0 33.2243 0 29.4961V6.99609C0 3.26784 3.02175 0.246094 6.75 0.246094H29.25C32.9782 0.246094 36 3.26784 36 6.99609V29.4961C36 33.2243 32.9782 36.2461 29.25 36.2461Z" fill={color}/>
  <path fillRule="evenodd" clipRule="evenodd" d="M26.0002 22.005L18.0377 25.9996L18.0371 18.0091L26.0002 14.0176V22.005Z" fill="#946F47"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M17.9631 25.9996L10 22.0051V14.0176L17.9631 18.0122V25.9996Z" fill="#B19255"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M26 13.9453L18 17.8906L10 13.9412L18 10L26 13.9453Z" fill="#BD9C5B"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M14.3501 20.3751L13.1704 19.8021V15.6992L14.3501 16.2722V20.3751Z" fill="#F7EECF"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M13.1704 15.4907L14.3322 16.064L22.4607 12.1075L21.2989 11.5342L13.1704 15.4907Z" fill="#FFF6D6"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M12.6544 17.3058L10.6099 16.7012L10.3687 15.4062L12.4131 16.0108L12.6544 17.3058Z" fill="white"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M10.9585 16.6484L10.9052 16.6346L10.7373 15.8447L10.7906 15.8585L10.9585 16.6484Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.1797 16.6484L11.1494 16.6414L10.9585 15.8447L10.9888 15.8517L11.1797 16.6484Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.2534 16.6484L11.2231 16.6414L11.0322 15.8447L11.0625 15.8517L11.2534 16.6484Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.2534 16.7216L11.2231 16.7147L11.0322 15.918L11.0625 15.9249L11.2534 16.7216Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.5483 16.8672L11.518 16.8602L11.3271 16.0635L11.3574 16.0704L11.5483 16.8672Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.3272 16.7216L11.2738 16.7078L11.106 15.918L11.1592 15.9318L11.3272 16.7216Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.4746 16.7216L11.4213 16.7078L11.2534 15.918L11.3067 15.9318L11.4746 16.7216Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.6221 16.8672L11.5688 16.8533L11.4009 16.0635L11.4542 16.0773L11.6221 16.8672Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.7695 16.8672L11.7393 16.8601L11.5483 16.0635L11.5787 16.0704L11.7695 16.8672Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.8433 16.8672L11.813 16.8602L11.6221 16.0635L11.6524 16.0704L11.8433 16.8672Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.8433 16.9404L11.813 16.9334L11.6221 16.1367L11.6524 16.1437L11.8433 16.9404Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M11.917 16.9404L11.8637 16.9266L11.6958 16.1367L11.7491 16.1505L11.917 16.9404Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M12.2857 17.0146L12.2553 17.0076L12.0645 16.2109L12.0948 16.2179L12.2857 17.0146Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M12.4331 17.0146L12.3798 17.0008L12.2119 16.2109L12.2652 16.2247L12.4331 17.0146Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M12.1382 16.9404L12.0849 16.9266L11.917 16.1367L11.9703 16.1505L12.1382 16.9404Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M12.2119 16.9404L12.1587 16.9266L11.9907 16.1367L12.044 16.1505L12.2119 16.9404Z" fill="#2C323D"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M17.2994 19.4978L14.7925 18.2245V17.0137L17.2994 18.2869V19.4978Z" fill="white"/>
  </svg>
  

  );
  
  ProductIcon.defaultProps = {
    color: "#E3F8FA",
    height: "37",
    width: "36"
  };

  export const VerticalAlignTop = ({ width, height, color }: IconProps): JSX.Element =>(
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z" fill={color}/>
</svg>
  );

  VerticalAlignTop.defaultProps ={
    color: "#FFF",
    height: "24",
    width: "24"
  };

  export const DoubleArrowIcon = ({width, height, color}: IconProps): JSX.Element => (
    <svg width={width} height={height} viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1903_11807)">
<path d="M13.31 1.49461C13.065 1.24961 12.67 1.24961 12.425 1.49461L8.27 5.64961C8.075 5.84461 8.075 6.15961 8.27 6.35461L12.425 10.5096C12.67 10.7546 13.065 10.7546 13.31 10.5096C13.555 10.2646 13.555 9.86961 13.31 9.62461L9.69 5.99961L13.315 2.37461C13.555 2.13461 13.555 1.73461 13.31 1.49461V1.49461Z" fill="white"/>
</g>
<g clip-path="url(#clip1_1903_11807)">
<path d="M8.31 1.49461C8.065 1.24961 7.67 1.24961 7.425 1.49461L3.27 5.64961C3.075 5.84461 3.075 6.15961 3.27 6.35461L7.425 10.5096C7.67 10.7546 8.065 10.7546 8.31 10.5096C8.555 10.2646 8.555 9.86961 8.31 9.62461L4.69 5.99961L8.315 2.37461C8.555 2.13461 8.555 1.73461 8.31 1.49461V1.49461Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_1903_11807">
<rect width="12" height="12" fill="white" transform="translate(17 12) rotate(180)"/>
</clipPath>
<clipPath id="clip1_1903_11807">
<rect width="12" height="12" fill="white" transform="translate(12 12) rotate(180)"/>
</clipPath>
</defs>
</svg>

  );

  DoubleArrowIcon.defaultProps ={
    color: "#fff",
    height: "12",
    width: "17"
  };

  export const ArrowLeftIcon = ({ width="100%", height="100%", color="#757A93" }: IconProps) =>  
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M64.208 69.125L45.1247 50L64.208 30.875L58.333 25L33.333 50L58.333 75L64.208 69.125Z" fill={color}/>
  </svg>;

export const ArrowRightIcon = ({ width="100%", height="100%", color="#757A93" }: IconProps) =>  
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M35.791 30.875L54.8743 50L35.791 69.125L41.666 75L66.666 50L41.666 25L35.791 30.875Z" fill={color}/>
  </svg>;


export const DownloadIcon = ({ width = "24", height = "24", color = "white" }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z" fill="#757A93" />
  </svg>
);

export const CloseButtonIcon = ({ width = "30", height = "30", color = "#707070" }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9.5" cy="9.5" r="8.75" fill="#4B4B4B" fillOpacity="0.5" stroke="#F8F5F5" strokeWidth="1.5" />
    <path
      d="M13.875 6.00625L12.9938 5.125L9.5 8.61875L6.00625 5.125L5.125 6.00625L8.61875 9.5L5.125 12.9938L6.00625 13.875L9.5 10.3812L12.9938 13.875L13.875 12.9938L10.3812 9.5L13.875 6.00625Z"
      fill={color}
    />
  </svg>
);

export const DownloadFileIcon = ({ width = "26", height = "32", color = "white" }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.9336 20.2871C6.6346 20.2871 6.4331 20.3159 6.3291 20.3447V22.2295C6.4526 22.2583 6.60698 22.2663 6.81985 22.2663C7.59823 22.2663 8.0776 21.8791 8.0776 21.2247C8.0776 20.6391 7.66485 20.2871 6.9336 20.2871ZM12.6 20.3063C12.275 20.3063 12.0637 20.3351 11.9386 20.3639V24.5399C12.0637 24.5687 12.2652 24.5687 12.4472 24.5687C13.7749 24.5783 14.6394 23.8583 14.6394 22.3351C14.6491 21.0071 13.861 20.3063 12.6 20.3063Z"
      fill="#F01616"
    />
    <path
      d="M16.25 0H3.25C2.38805 0 1.5614 0.337142 0.951903 0.937258C0.34241 1.53737 0 2.35131 0 3.2V28.8C0 29.6487 0.34241 30.4626 0.951903 31.0627C1.5614 31.6629 2.38805 32 3.25 32H22.75C23.612 32 24.4386 31.6629 25.0481 31.0627C25.6576 30.4626 26 29.6487 26 28.8V9.6L16.25 0ZM8.93425 22.704C8.43213 23.168 7.69112 23.376 6.82825 23.376C6.66094 23.3778 6.49371 23.3682 6.32775 23.3472V25.6288H4.875V19.3312C5.53061 19.2349 6.19307 19.191 6.85588 19.2C7.761 19.2 8.4045 19.3696 8.83838 19.7104C9.25113 20.0336 9.53062 20.5632 9.53062 21.1872C9.529 21.8144 9.31775 22.344 8.93425 22.704ZM15.1206 24.872C14.4381 25.4304 13.3998 25.696 12.1306 25.696C11.3701 25.696 10.8322 25.648 10.4666 25.6V19.3328C11.1225 19.2385 11.7847 19.1941 12.4475 19.2C13.6776 19.2 14.4771 19.4176 15.1011 19.8816C15.7755 20.3744 16.198 21.16 16.198 22.288C16.198 23.5088 15.7446 24.352 15.1206 24.872ZM21.125 20.432H18.6355V21.8896H20.9625V23.064H18.6355V25.6304H17.1632V19.248H21.125V20.432ZM16.25 11.2H14.625V3.2L22.75 11.2H16.25Z"
      fill="#F01616"
    />
  </svg>
);

